import { EDesktopListingView } from '../../types/desktopListing';
import { IApplicationState } from '../../types/redux';

export const selectDesktopListingView = (state: IApplicationState) => {
  return state.desktopListing.view;
};

export const selectIsDesktopListingVisible = (state: IApplicationState) => {
  return state.desktopListing.view === EDesktopListingView.VISIBLE;
};
